import { BLOCK_CLASSES as e, DISALLOWED_COLOR_VALUES as t, FONT_FAMILIES as n } from "../../constants.js";
import { defineAttrs as r } from "../../utils/typed-attrs.js";
import { tinycolor as i } from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
import { toAlphaPreservingHex as a } from "../nodes/spec-util.js";
//#region src/specs/decorators/stylable.ts
var o = r({
	fontFamily: { default: "" },
	fontColor: { default: "" },
	backgroundColor: { default: "" },
	paddingTop: { default: "" },
	paddingBottom: { default: "" },
	paddingLeft: { default: "" },
	paddingRight: { default: "" },
	borderRadius: { default: "" },
	borderColor: { default: "" },
	borderWidth: { default: "" },
	borderStyle: { default: "" }
});
function s(e) {
	let t = "";
	return e.attrs.paddingTop && (t += `padding-top: ${e.attrs.paddingTop}; `), e.attrs.paddingBottom && (t += `padding-bottom: ${e.attrs.paddingBottom}; `), e.attrs.paddingLeft && (t += `padding-left: ${e.attrs.paddingLeft}; `), e.attrs.paddingRight && (t += `padding-right: ${e.attrs.paddingRight}; `), t;
}
function c(r) {
	r.attrs = Object.assign({}, r.attrs, {
		fontFamily: { default: "" },
		fontColor: { default: "" },
		backgroundColor: { default: "" },
		paddingTop: { default: "" },
		paddingBottom: { default: "" },
		paddingLeft: { default: "" },
		paddingRight: { default: "" },
		borderRadius: { default: "" },
		borderColor: { default: "" },
		borderWidth: { default: "" },
		borderStyle: { default: "" }
	}), r.parseDOM?.forEach(function(r) {
		let o = r.getAttrs;
		r.getAttrs = (r) => {
			let s = {};
			o && Object.assign(s, o(r));
			let { fontFamily: c, color: u, borderRadius: d, paddingTop: f, paddingBottom: p, paddingLeft: m, paddingRight: h } = r?.style || {};
			if (c && n.includes(c) && Object.assign(s, { fontFamily: c }), u && !t.includes(u)) {
				let e = i(u);
				if (e.isValid()) {
					let t = a(e);
					Object.assign(s, { fontColor: t });
				}
			}
			if ((f || m || h || p) && Object.assign(s, {
				paddingTop: f,
				paddingLeft: m,
				paddingRight: h,
				paddingBottom: p
			}), d && Object.assign(s, { borderRadius: d }), r.classList.contains(e.button) || r.classList.contains("intercom-interblocks-button")) {
				let e = l(r.firstChild);
				Object.assign(s, e);
			}
			return s;
		};
	});
	let o = r.toDOM;
	return r.toDOM = (e) => {
		if (!o) throw Error("must specify a toDOM method");
		let t = o(e);
		if (!Array.isArray(t) || t.length < 2) throw Error("must specify at least two elements in output spec");
		t[1] === 0 && t.splice(1, 0, {});
		let n = t[1], r = t[2] ? t[2][1] : {};
		return n.style ??= "", r.style ??= "", e.attrs.fontFamily && (n.style += `font-family: ${e.attrs.fontFamily}; `), e.attrs.borderRadius && (r.style += `border-radius: ${e.attrs.borderRadius}; `), e.attrs.fontColor && (n.style += `color: ${e.attrs.fontColor}; `), e.attrs.backgroundColor && (e.attrs.responsive ? r.style += `background-color: ${e.attrs.backgroundColor}; ` : e.type.name !== "button" && !e.attrs.container && (n.style += `background-color: ${e.attrs.backgroundColor}; `)), e.attrs.borderColor && (n.style += `border-color: ${e.attrs.borderColor}; `), u(e) && (e.attrs.container ? n.style += s(e) : (r.style += s(e), e.attrs.responsive && (r.style += "border-collapse: separate; "))), n.style = n.style.trim(), r.style = r.style.trim(), n.style === "" && (n.style = null), r.style === "" && (r.style = null), t;
	}, r;
}
function l(e) {
	let { paddingTop: t, paddingRight: n, paddingLeft: r, paddingBottom: i, borderRadius: a, borderColor: o, borderWidth: s, borderStyle: c } = e?.style || {};
	return {
		paddingTop: t,
		paddingRight: n,
		paddingLeft: r,
		paddingBottom: i,
		borderRadius: a,
		borderColor: o,
		borderWidth: s,
		borderStyle: c
	};
}
function u(e) {
	let { paddingTop: t, paddingRight: n, paddingLeft: r, paddingBottom: i } = e.attrs;
	return !!(t || n || r || i);
}
//#endregion
export { s as getPaddingStyles, c as stylable, o as stylableAttrs };
